module.exports = __webpack_public_path__ + "static/media/swimming_pool.db4e93e2.svg";